"use client";

import { ConnectWallet } from "@/components/ConnectWallet";
import { Badge } from "@/components/ui/badge";
import { StepCard } from "./StepCard";
import type { StepStatus } from "./types";

interface Step1Props {
  status: StepStatus;
  isConnected: boolean;
  address: string | null;
}

export function Step1ConnectWallet({ status, isConnected, address }: Step1Props) {
  return (
    <StepCard
      stepNumber={1}
      title="Connect Wallet"
      description="Link your Stellar wallet to begin"
      status={status}
      completedSummary={
        address && (
          <div className="flex items-center gap-2">
            <span className="inline-block w-2 h-2 rounded-full bg-green-500" />
            <span className="font-mono text-xs">
              {address.slice(0, 8)}...{address.slice(-8)}
            </span>
            <Badge variant="outline" className="text-xs ml-auto">TESTNET</Badge>
          </div>
        )
      }
    >
      <div className="space-y-3">
        <ConnectWallet />
        {isConnected && address && (
          <div className="flex items-center gap-2 text-sm">
            <span className="inline-block w-2 h-2 rounded-full bg-green-500" />
            <span className="text-muted-foreground">Connected:</span>
            <span className="font-mono text-xs">
              {address.slice(0, 8)}...{address.slice(-8)}
            </span>
            <Badge variant="outline" className="text-xs ml-auto">TESTNET</Badge>
          </div>
        )}
      </div>
    </StepCard>
  );
}
